import React from 'react';

export function Navigation({ activeModule, setActiveModule }) {
  const items = [
    { key: 'all', label: 'Todo' },
    { key: 'materials', label: 'Materiales' },
    { key: 'stock', label: 'Stock' },
    { key: 'pending', label: 'Pedidos pendientes' },
    { key: 'entry', label: 'Entradas' },
    { key: 'assignment', label: 'Asignaciones' },
    { key: 'loan', label: 'Préstamos' },
    { key: 'return', label: 'Devoluciones' },
    { key: 'exit', label: 'Salidas' },
    { key: 'transfer', label: 'Traslados' },
    { key: 'movements', label: 'Movimientos' },
  ];

  return (
    <div className="w-full bg-white border-b border-gray-200">
      <div className="max-w-6xl mx-auto px-4 py-2 flex gap-2 flex-wrap">
        {items.map((item) => (
          <button
            key={item.key}
            type="button"
            onClick={() => setActiveModule(item.key)}
            className="px-3 py-1.5 rounded-md text-sm font-medium focus:outline-none"
            style={{
              backgroundColor: activeModule === item.key ? '#F07E2D' : '#776F74',
              color: 'white',
              border: activeModule === item.key ? '2px solid #F07E2D' : '1px solid rgba(0,0,0,0.06)',
            }}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
}
